import { combineReducers } from "redux";
import { ACTION } from "./constants";

const initialState = {
  mfBytes: [],
};
export default function mfBytesReducer(state = initialState, action) {
  switch (action.type) {
      case ACTION.GET_MFBYTES_METADATA:
        return { ...state, mfbyesmetaData: action.data }
    default:
      return state;
  }
}
